<template>

    <div>

        <div v-if="currentOpinion && Array.isArray(currentOpinion)" class="window" >

            <nav v-if="currentOpinion.length > 1">
                <div>
                    <button class="btn btn-secondary btn-sm" v-on:click="goBack">Föregående</button>
                    <button class="btn btn-secondary btn-sm" v-on:click="goToNext">Nästa</button>
                </div>
                <div>
                    Visar svar: {{ activeItem + 1 }} av {{ currentOpinion.length  }}
                </div>
            </nav>

            <div class="show-pin" :class="{ active: index === activeItem || currentOpinion.length === 0 }" v-for="(opinion, index) in currentOpinion" :key="index">

                <span class="close-popup" @click="closeWindow"><i class="fas fa-times"></i></span>

                <div :class="opinion.value_type === 'bad' ? 'opinion bad-opinion' : 'opinion'">

                    <div v-if="opinion.comment || opinion.image" class="top">

                        <p>{{ opinion.comment }}</p>

                        <div v-if="opinion.image && opinion.image.name !== '' ">
                            <img class="answer-image" :src="'/images/projects/answer-images/' + getNameAndExt(opinion.image).name + '_300.' + getNameAndExt(opinion.image).ext" />
                        </div>

                    </div>

                    <div :class="(opinion.value_type === 'good' || opinion.value_type === 'bad' ? 'bottom' : 'bottom no-after')">

                        <div :class="(opinion.value_type === 'good' || opinion.value_type === 'bad' ? 'good-bad' : 'good-bad no-value')">{{ getLabels(slide, opinion.value_type) }}</div>

                        <ul v-if="opinion.values.length" class="options">
                            <li v-for="(val, i) in filterListingOptions(opinion.values, slide)" :key="i">#{{ val.val }}</li>
                        </ul>

                        <div class="info">
                            <div :class="(opinion.values && opinion.values.length) ? 'sex' : 'sex no-options'" v-if="opinion.answer_data && opinion.answer_data.sex">{{ opinion.answer_data.sex }}</div>
                            <div class="age" v-if="opinion.answer_data && opinion.answer_data.age">{{ opinion.answer_data.age }} år</div>
                            <div class="type" v-if="opinion.answer_data && opinion.answer_data.type">{{ opinion.answer_data.type }}</div>
                        </div>

                        <div class="time-wrapper">
                            <div class="time" v-if="opinion.answer_data && opinion.answer_data.created_date">{{ opinion.answer_data.created_date }}</div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import Slick from "vue-slick";

import { slickOptionsOpinion }from "./../../../tool/settings";
import { getLabelForGoodBad } from './../../../tool/translations'
import { showReportArea, filtredOptions, getFileInfo } from './../../../tool/functions'
import { Fragment } from 'vue-fragment'

export default {

    components: {
        Slick,
        Fragment,
    },

    data() {
        return {
            slickOptions: slickOptionsOpinion,
            todayDate : new Date(),
            activeItem : 0
        };
    },

    props: {
        currentOpinion: Array,
        slide : Object
    },

    methods: {

        getNameAndExt: function(file) {
            return getFileInfo(file)
        },

        filterListingOptions: function() {
            return filtredOptions.apply(null, arguments)
        },

        getLabels: function() {
            return getLabelForGoodBad.apply(null, arguments)
        },

        closeWindow: function() {
            this.$emit('close-popup')
        },

        goBack: function() {
            this.activeItem = this.activeItem - 1;

            if(this.activeItem < 0) {
                this.activeItem = this.currentOpinion.length - 1;
            }
        },

        goToNext: function() {
            this.activeItem = this.activeItem + 1;

            if(this.activeItem === this.currentOpinion.length) {
                this.activeItem = 0;
            }
        },

    }
};
</script>


